import { serviceSettingActions } from '../../../controller';
import { SocketTypeEnums } from '../../../../lib/enums';

const {
	SERVICE_SETTING_EVENT_UPDATED,
} = SocketTypeEnums;
const {
	updateServiceSettingAction,
} = serviceSettingActions;

export function updatedServiceSettingEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(SERVICE_SETTING_EVENT_UPDATED, ({ data }) => {
		dispatch(updateServiceSettingAction(data));
	});
}
